<template>
    <div id="popChoose">
        <div class="chooseBox">
            <div class="titles">是否放弃任务？</div>
            <div class="btnBox">
                <div class="btn1" @click="giveUp">放弃</div>
                <div class="btn2" @click="notGiveUp">不放弃</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components:{

        },
        data() {
            return {
                
            }
        },
        methods: {
            giveUp:function(){
                this.$emit('giveUp');
            },
            notGiveUp:function(){
                this.$emit('notGiveUp');
            }
        },
    }
</script>

<style lang="less" scoped>
    #popChoose{
        position:fixed;
        left:0;
        top:0;
        width:100%;
        height:100%;
        z-index:10;
        background:rgba(127,127,127,.5);
        .chooseBox{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            width:240px;
            // height:114px;
            padding: 20px;
            background:rgba(255,255,255,1);
            border-radius:8px;
            .titles{
                font-size:16px;
                font-weight:600;
                color:rgba(51,51,51,1);
                line-height:22px;
                text-align: center;
                margin: 12px 0 32px;
            }
            .btnBox{
                display: flex;
                justify-content: space-between;
                .btn1{
                    width:114px;
                    height:40px;
                    border-radius:22px;
                    border:1px solid rgba(153,153,153,1);
                    font-size:16px;
                    font-weight:500;
                    color:rgba(153,153,153,1);
                    line-height:40px;
                    text-align: center;
                }
                .btn2{
                    width:114px;
                    height:40px;
                    background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
                    box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
                    border-radius:20px;
                    font-size:16px;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    line-height:40px;
                    text-align: center;
                }
            }
        }
    }
</style>